export enum MessageId {
    // ## Error messages ##
    // Entries
    AnnotationUpdate_SaveError = "ANNOTATION_UPDATE_SAVE_ERROR",
    CleanEntries_ConfirmationError = "CLEAN_ENTRIES_CONFIRMATION_ERROR",
    CleanEntries_Error = "CLEAN_ENTRIES_ERROR",
    ClearAll_ConfirmationError = "CLEAR_ALL_CONFIRMATION_ERROR",
    ClearAll_WithoutTagsError = "CLEAR_ALL_WITHOUT_TAGS_ERROR",
    ClearAll_Error = "CLEAR_ALL_ERROR",
    ClearAll_TagError = "CLEAR_ALL_TAG_ERROR",
    EntryAdd_Error = "ENTRY_ADD_ERROR",
    EntryAdd_TooManyError = "ENTRY_ADD_TOO_MANY_ERROR",
    EntryDelete_Error = "ENTRY_DELETE_ERROR",
    EntryList_Error = "ENTRY_LIST_ERROR",
    // Shared
    SharedList_Error = "SHARED_LIST_ERROR",
    ShareEntries_Error = "SHARE_ENTRIES_ERROR",
    ShareEntries_NoEntriesError = "SHARE_ENTRIES_NO_ENTRIES_ERROR",
    ShareEntries_TagError = "SHARE_ENTRIES_TAG_ERROR",
    ShareEntries_TagNoEntriesError = "SHARE_ENTRIES_TAG_NO_ENTRIES_ERROR",
    ShareEntries_WithoutTagsNoEntriesError = "SHARE_ENTRIES_WITHOUT_TAGS_NO_ENTRIES_ERROR",
    ShareEntries_WithoutTagsError = "SHARE_ENTRIES_WITHOUT_TAGS_ERROR",
    // Tags
    TagAdd_Error = "TAG_ADD_ERROR",
    TagAdd_Limit_Error = "TAG_ADD_LIMIT_ERROR",
    TagAdd_AlreadyExistsError = "TAG_ADD_EXISTS_ERROR",
    TagApply_Error = "TAG_APPLY_ERROR",
    TagDelete_Error = "TAG_DELETE_ERROR",
    TagList_Error = "TAG_LIST_ERROR",
    TagRemove_Error = "TAG_REMOVE_ERROR",
    TagRename_Error = "TAG_RENAME_ERROR",
    TagRenameEmptyError = "TAG_RENAME_EMPTY_ERROR",
    TagRenameExistsError = "TAG_RENAME_EXISTS_ERROR",
    TagRenameNoChangeError = "TAG_RENAME_NO_CHANGE_ERROR",
    // Others
    UserError = "USER_ERROR",
    // ####################

    // ## Success messages ##
    // Entries
    AnnotationUpdate_SaveSuccess = "ANNOTATION_UPDATE_SAVE_SUCCESS",
    CleanEntries_Success = "CLEAN_ENTRIES_SUCCESS",
    ClearAll_WithoutTagsSuccess = "CLEAR_ALL_WITHOUT_TAGS_SUCCESS",
    ClearAll_Success = "CLEAR_ALL_SUCCESS",
    ClearAll_TagSuccess = "CLEAR_ALL_TAG_SUCCESS",
    EntryAdd_Success = "ENTRY_ADD_SUCCESS",
    EntryDelete_Success = "ENTRY_DELETE_SUCCESS",
    EntryList_Success = "ENTRY_LIST_SUCCESS",
    // Shared
    SharedList_Success = "SHARED_LIST_SUCCESS",
    ShareEntries_WithoutTagsSuccess = "SHARE_ENTRIES_WITHOUT_TAGS_SUCCESS",
    ShareEntries_Success = "SHARE_ENTRIES_SUCCESS",
    ShareEntries_TagSuccess = "SHARE_ENTRIES_TAG_SUCCESS",
    // Tags
    TagAddSuccess = "TAG_ADD_SUCCESS",
    TagApplySuccess = "TAG_APPLY_SUCCESS",
    TagDeleteSuccess = "TAG_DELETE_SUCCESS",
    TagListSuccess = "TAG_LIST_SUCCESS",
    TagRemoveSuccess = "TAG_REMOVE_SUCCESS",
    TagRenameSuccess = "TAG_RENAME_SUCCESS",
    // ######################
}

const messages = {
    // ## Error messages ##
    // Entries
    [MessageId.AnnotationUpdate_SaveError]: (): string => "Die Notiz/Bewertung konnte nicht gespeichert werden.",
    [MessageId.CleanEntries_ConfirmationError]: (): string =>
        "Das Entfernen veralteter Einträge muss erst bestätigt werden.",
    [MessageId.ClearAll_ConfirmationError]: (): string => "Das Entfernen aller Einträge muss erst bestätigt werden.",
    [MessageId.ClearAll_WithoutTagsError]: (): string => "Merkzettel-Einträge ohne Tags konnten nicht entfernt werden.",
    [MessageId.ClearAll_Error]: (): string => "Merkzettel-Einträge konnten nicht entfernt werden.",
    [MessageId.ClearAll_TagError]: (tagName: string): string =>
        `Merkzettel-Einträge für das Tag "${tagName}" konnten nicht entfernt werden.`,
    [MessageId.EntryAdd_Error]: (): string => "Die Anzeige konnte nicht zum Merkzettel hinzugefügt werden.",
    // ToDo: Is this still relevant? Will we have a limit?
    [MessageId.EntryAdd_TooManyError]: (maxAmount: number): string =>
        `Dein Merkzettel ist voll. Du kannst maximal ${maxAmount} Anzeigen im Merkzettel speichern.`,
    [MessageId.CleanEntries_Error]: (): string => "Merkzettel-Einträge konnten nicht entfernt werden.",
    [MessageId.EntryDelete_Error]: (): string => "Die Anzeige konnte nicht vom Merkzettel entfernt werden.",
    [MessageId.EntryList_Error]: (): string => "Einträge konnten nicht abgerufen werden.",
    // Shared
    [MessageId.SharedList_Error]: (): string => "Die Favoritenliste konnte nicht abgerufen werden.",
    [MessageId.ShareEntries_Error]: (): string => "Favoriten-Key konnte nicht erstellt werden.",
    [MessageId.ShareEntries_NoEntriesError]: (): string => "Es gibt keine Einträge zum teilen.",
    [MessageId.ShareEntries_TagError]: (tagName: string): string =>
        `Das Tag "${tagName}" ist leer und kann nicht geteilt werden!`,
    [MessageId.ShareEntries_TagNoEntriesError]: (): string => "Es gibt keine Einträge ohne Tags zum teilen.",
    [MessageId.ShareEntries_WithoutTagsError]: (tagName: string): string =>
        `Das Tag "${tagName}" ist leer und kann nicht geteilt werden!`,
    [MessageId.ShareEntries_WithoutTagsNoEntriesError]: (): string => "Es gibt keine Einträge ohne Tags zum teilen.",
    // Tags
    [MessageId.TagAdd_Error]: (): string => "Beim anlegen des Tag trat ein Fehler auf.",
    [MessageId.TagAdd_Limit_Error]: (): string => "Maximale Anzahl der Tags von 10 erreicht!",
    [MessageId.TagAdd_AlreadyExistsError]: (): string =>
        "Dieser Tagname ist bereits vergeben, bitte wähle einen anderen.",
    [MessageId.TagApply_Error]: (tagName: string): string =>
        `Das Tag "${tagName}" konnte dem Eintrag nicht zugewiesen werden.`,
    [MessageId.TagDelete_Error]: (tagName: string): string => `Das Tag "${tagName}" konnte nicht gelöscht werden.`,
    [MessageId.TagList_Error]: (): string => "Tags konnten nicht abgerufen werden.",
    [MessageId.TagRemove_Error]: (tagName: string): string =>
        `Das Tag "${tagName}" konnte nicht vom Eintrag entfernt werden.`,
    [MessageId.TagRename_Error]: (): string => "Beim umbenennen des Tag ist ein Fehler aufgetreten.",
    [MessageId.TagRenameEmptyError]: (): string => "Der neue Tagname darf nicht leer sein.",
    [MessageId.TagRenameExistsError]: (tagName: string): string => `Der Tagname "${tagName}" existiert bereits.`,
    [MessageId.TagRenameNoChangeError]: (): string => "Der neue Tagname entspricht dem alten Tagnamen.",
    // Others
    [MessageId.UserError]: (): string => "Du bist nicht berechtigt, diese Aktion auszuführen.",
    // ####################

    // ## Success messages ##
    // Entries
    [MessageId.AnnotationUpdate_SaveSuccess]: (): string => "Die Notiz/Bewertung wurde erfolgreich gespeichert.",
    [MessageId.ClearAll_WithoutTagsSuccess]: (): string =>
        "Alle Einträge ohne Tag wurden erfolgreich aus deinem Merkzettel entfernt",
    [MessageId.ClearAll_Success]: (): string => "Alle Einträge wurden erfolgreich aus deinem Merkzettel entfernt.",
    [MessageId.ClearAll_TagSuccess]: (tagName: string): string =>
        `Alle Einträge mit dem Tag "${tagName}" wurden erfolgreich aus deinem Merkzettel entfernt`,
    [MessageId.EntryAdd_Success]: (): string => "Die Anzeige wurde erfolgreich zum Merkzettel hinzugefügt.",
    [MessageId.CleanEntries_Success]: (): string =>
        "Alle veralteten Einträge wurden erfolgreich aus deinem Merkzettel entfernt.",
    [MessageId.EntryDelete_Success]: (): string => "Die Anzeige wurde erfolgreich aus dem Merkzettel entfernt.",
    [MessageId.EntryList_Success]: (): string => "",
    // Shared
    [MessageId.SharedList_Success]: (): string => "",
    [MessageId.ShareEntries_Success]: (): string => "Alle Einträge wurden erfolgreich geteilt.",
    [MessageId.ShareEntries_TagSuccess]: (tagName: string): string =>
        `Alle Einträge mit dem Tag "${tagName}" wurden erfolgreich geteilt.`,
    [MessageId.ShareEntries_WithoutTagsSuccess]: (): string =>
        "Alle Einträge mit ohne Tags wurden erfolgreich geteilt.",
    // Tags
    [MessageId.TagAddSuccess]: (tagName: string): string => `Das Tag "${tagName}" wurde erfolgreich angelegt.`,
    [MessageId.TagApplySuccess]: (tagName: string): string =>
        `Das Tag "${tagName}" wurde erfolgreich vom Eintrag entfernt.`,
    [MessageId.TagDeleteSuccess]: (tagName: string): string => `Das Tag "${tagName}" wurde erfolgreich gelöscht.`,
    [MessageId.TagListSuccess]: (): string => "",
    [MessageId.TagRemoveSuccess]: (tagName: string): string =>
        `Das Tag "${tagName}" wurde dem Eintrag erfolgreich zugewiesen.`,
    [MessageId.TagRenameSuccess]: (oldTagName: string, newTagName: string): string =>
        `Der Tag "${oldTagName}" wurde erfolgreich umbenannt in "${newTagName}".`,
} as const satisfies Record<MessageId, (...args: any[]) => string>

type MessagesMap = typeof messages

export function getMessageTemplateById<K extends keyof MessagesMap>(id: K): MessagesMap[K] {
    return messages[id]
}
